export default "__VITE_ASSET__f9ec821b__"